WYATT.registerComponent(
  "video-player",
  class VideoPlayer extends HTMLElement {
    async connectedCallback() {
      this.videoType = this.dataset.videoType;
      this.videoId = this.dataset.videoId;
      this.previewImageSrc = this.dataset.videoPreviewImage;

      if (this.videoType === "youtube") {
        this.previewImageSrc =
          this.previewImageSrc ??
          `https://i.ytimg.com/vi/${this.videoId}/maxresdefault.jpg`;
        this.videoSrc = `https://www.youtube.com/embed/${this.videoId}`;
      } else {
        this.previewImageSrc =
          this.previewImageSrc ?? (await this.fetchVimeoPreviewImageSrc());
        this.videoSrc = `https://player.vimeo.com/video/${this.videoId}`;
      }

      this.bindEvents();
    }

    async fetchVimeoPreviewImageSrc() {
      const response = await fetch(
        `https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/${this.videoId}&format=json&width=1200`
      );
      const data = await response.json();
      return data.thumbnail_url;
    }

    bindEvents() {
      this.renderPreviewImage();
      this.addEventListener("click", this.renderVideo.bind(this));

      const dialog = this.closest("[data-modal]");

      if (dialog) {
        dialog.addEventListener("modalOpen", () => {
          // JS sizes the iframe based on the preview image dimensions.
          // But when in a dialog, that image has no dimensions.
          // So we remove the lazy loading attribute to trigger a load
          // and then wait for that to complete before rendering the iframe.
          this.previewImage.removeAttribute("loading");
          this.previewImage.addEventListener(
            "load",
            this.renderVideo.bind(this)
          );
        });

        dialog.addEventListener("modalClose", () => {
          this.reset();
        });
      }
    }

    renderPreviewImage() {
      const playButton = this.getElementsByTagName("button")[0];
      this.previewImage = document.createElement("img");
      this.previewImage.setAttribute("src", this.previewImageSrc);
      this.previewImage.setAttribute("class", "video-player__preview-image");
      this.previewImage.setAttribute("loading", "lazy");
      playButton.append(this.previewImage);
    }

    renderVideo() {
      this.iframe = document.createElement("iframe");
      const thumbnail = this.getElementsByTagName("button")[0];
      const width = thumbnail.offsetWidth;
      const height = thumbnail.offsetHeight;

      this.iframe.setAttribute(
        "src",
        `${this.videoSrc}?autoplay=1&enablejsapi=1`
      );
      this.iframe.setAttribute("frameborder", "0");
      this.iframe.setAttribute("allowfullscreen", "1");
      this.iframe.setAttribute("allow", "autoplay; encrypted-media");
      this.iframe.setAttribute("class", "video-player__iframe");
      this.iframe.setAttribute("width", width);
      this.iframe.setAttribute("height", height);

      this.appendChild(this.iframe);
      this.classList.add("video-player--playing");
    }

    reset() {
      this.iframe.remove();
      this.classList.remove("video-player--playing");
    }
  }
);
